export const GET_LOCATIONS = '/get_barangays';
export const GET_SINGLE_LOCATION = '/get_single_barangay';
export const UPDATE_LOCATION = '/update_location';
export const CREATE_LOCATION = '/create_location';
export const REMOVE_LOCATION = '/remove_location';
export const GET_BARANGAY_LIST = 'location/get_barangay_list';
export const GET_DISTRICT_LIST = 'location/get_district_list';

export const FORM_DATA = {
  name: '',
  rptax_barangay_id: '',
  rptax_district_id: '',
};